import { cr } from "fire-wind-water";
import URL from "@/assets/conf/setting.json";
import SETTURL from "../assets/conf/setting.json";
import { resetURL } from "../../stempcore/src/sbase";
window.$sk.setApiUrl(URL.template.api.gateway.general);
window.$sk.setUploadUrl(URL.sbaseUrl);
resetURL(SETTURL);
export const api = {
  cacheParams: {
    _cache_with_cached: 1,
    _cache_refresh: 0,
    _cache_timeout: 300,
  },
};
export default {
  getForNewForm(params) {
    return window.$sk.$skxhrp("member/form/GetForNewForm", params);
  },
  login(params) {
    return window.$sk.$skxhrp("member/login", params);
  },
  getJsonParams(params) {
    return window.$sk.$skxhrp(
      "api/common/jsonParams/get",
      cr.extend(params, api.cacheParams)
    );
  },
  getUnique(params) {
    return window.$sk.$skxhrp("member/form/getUnique", params);
  },
  memberLogin(params) {
    return window.$sk.$skxhrp("member/login", params);
  },
  getToken(params) {
    return window.$sk.$skxhrp("member/GetToken", params);
  },
  sendCheckCode(params) {
    return window.$sk.$skxhrp("member/sendCheckCode", params);
  },
  getFormNewRegister(params) {
    return window.$sk.$skxhrp(
      "api/member/form/get",
      cr.extend(params, api.cacheParams)
    );
  },
  getForm(params) {
    return window.$sk.$skxhrp(
      "member/form/GetForNewForm",
      cr.extend(params, api.cacheParams)
    );
  },
  register(params) {
    return window.$sk.$skxhrp("member/register", params);
  },
  getParamTree(params) {
    return window.$sk.$skxhrp("dic/params/getTree", params);
  },
  orderUnique(params) {
    return window.$sk.$skxhrp("member/schema/orderUnique", params);
  },
  checkUnique(params) {
    return window.$sk.$skxhr("member/checkUnique", params);
  },
  checkCode(params) {
    return window.$sk.$skxhrp("member/checkCode", params);
  },
  forgetPwd(params) {
    return window.$sk.$skxhrp("member/forgetPwd", params);
  },
  lookUp(params) {
    return window.$sk.$skxhrp("member/LookUp", params);
  },
  update(params) {
    return window.$sk.$skxhrp("api/member/contacts/info/update", params);
  },
  record(params) {
    return window.$sk.$skxhrp("member/interaction/record", params);
  },
  getTemplateConfig(params) {
    return window.$sk.$skxhr("template/platform/instance/getConfig", params);
  },
  getMyInfo(params) {
    return window.$sk.$skxhrp("api/member/contacts/info/get", params);
  },
  logout(params) {
    return window.$sk.$skxhrp("member/member/associate/Logout", params);
  },
  getDomain(tenantId) {
    return window.$sk.$skxhrp("api/domain/GetDomain", { tenantId: tenantId });
  },
  // 检查推广链接状态
  checkTrackStatus: (info) => {
    return window.$sk.$skxhrp("api/channel/track/info", info);
  },
};
